import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { loadAssetsThunk } from '../../store/assets/assetsThunks'
import { RootState, AppDispatch } from '../../store'
import './Loading.css'

function Loading() {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [languageLoaded, setLanguageLoaded] = useState(false)
  const [languageAttempted, setLanguageAttempted] = useState(false)

  // Check for access token in storage
  const token =
    localStorage.getItem('access_token') || sessionStorage.getItem('access_token')
  const isAuthenticated = !!token

  const loading = useSelector((state: RootState) => state.assets.loading)
  const loaded = useSelector((state: RootState) => state.assets.loaded)

  // Load language when user is authenticated
  useEffect(() => {
    const initializeLanguage = async () => {
      if (!isAuthenticated || languageAttempted) {
        setLanguageLoaded(true) // Skip language loading for unauthenticated users or if already attempted
        return
      }

      setLanguageAttempted(true) // Prevent multiple attempts

      try {
        console.log('Loading user language...')
        setLanguageLoaded(true)
      } catch (error) {
        console.error('Failed to load language:', error)
        // If language loading fails (e.g., 401, network error), continue with default language
        console.log('Continuing with default language due to error')
        setLanguageLoaded(true)
      }
    }

    initializeLanguage()
  }, [isAuthenticated, languageAttempted])

  // Load assets after language is initialized
  useEffect(() => {
    if (isAuthenticated && languageLoaded && !loading && !loaded) {
      console.log('Loading assets...')
      dispatch(loadAssetsThunk())
    }
  }, [isAuthenticated, languageLoaded, loading, loaded, dispatch])

  // Navigate based on authentication, language, and asset loading state
  useEffect(() => {
    if (!isAuthenticated) {
      // User not logged in → Go to /welcome after 1.5s
      const timeout = setTimeout(() => {
        navigate('/welcome')
      }, 1500)
      return () => clearTimeout(timeout)
    }

    // User logged in → Navigate to /home when language is loaded, assets are loaded, and not loading
    if (isAuthenticated && languageLoaded && loaded && !loading) {
      console.log('Everything loaded, navigating to home')
      navigate('/home')
    }
  }, [isAuthenticated, languageLoaded, loaded, loading, navigate])

  return (
    <div className="loading-container">
      <img
        src="/img/EnergyManager_Dark_Regular.png"
        alt="Loading"
        className="loading-logo"
        width="200"
      />
      {/* Optional: Show what's being loaded */}
      <div className="loading-status" style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        {!isAuthenticated && 'Checking authentication...'}
        {isAuthenticated && !languageLoaded && 'Loading language preferences...'}
        {isAuthenticated && languageLoaded && loading && 'Loading assets...'}
        {isAuthenticated && languageLoaded && loaded && 'Ready!'}
      </div>
    </div>
  )
}

export default Loading